export default {
  items: [
    {
      packingId: '000000000021000002',
      amount: -6559,
    },
    {
      packingId: '000000000021000003',
      amount: -34588,
    },
    {
      packingId: '000000000021000004',
      amount: 0,
    },
    {
      packingId: 'RTI-24603-CONT',
      amount: 2049,
    },
    {
      packingId: 'RTI-46-CONT',
      amount: -38594,
    },
  ],
  totalItems: 5,
};
